module.exports = "https://cdn.dove.it/_next/static/public/assets/agents/cherubini.3a20d264dab5fa64f9e1c0b3499b5f2d.png";